import { BaseHeader } from "@cmde/shadcn";
import { AppLocaleSelector } from "@/components/elements/locale-selector";
import { AppHeaderLogo } from "@/components/layouts/app-header-logo";
import { AppUserSection } from "@/components/layouts/app-user-section";

export const AppHeader = () => (
  <BaseHeader
    className="px-2 @container"
    logo={<AppHeaderLogo />}
    userSection={<AppUserSection />}
    languageSelector={
      <div className="hidden md:block">
        <AppLocaleSelector />
      </div>
    }
  />
);
